import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { DateLabel, TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatCPF } from '@format';
import { Grid, Typography } from '@material-ui/core';
import DadosContatoVisualizar from 'app/main/fornecedor/container/visualizar/DadosContatoVisualizar';
import { ContaBancariaVisualizar } from 'app/main/pessoa/ContaBancaria';
import { EnderecoVisualizar } from 'app/main/pessoa/Endereco';
import React, { useContext, useState } from 'react';
import { FaUsers } from 'react-icons/fa';
import { ClienteContext } from '../../../ClienteContext';
import { clienteModais } from '../clienteModais';

const TIPO_PESSOAS = {
  FISICA: 'Física',
  JURIDICA: 'Jurídica',
  ESTRANGEIRA: 'Empresa Estrangeira',
};

const INDICADORES = {
  CONTRIBUINTE: 'Contribuinte de ICMS',
  NAO_CONTRIBUINTE: 'Não contribuinte de ICMS',
  ISENTO: 'Contribuinte isento',
};

const TIPO_INDICADOR_OPERACAO = {
  NAO_APLICA: '0 - Não se aplica',
  INTERNA: '1 - Interna',
  INTERESTADUAL: '2 - Interestadual',
  EXTERIOR: '3 - Exterior',
};

const VisualizarClienteModal = () => {
  const [modal, setModal] = useContext(ClienteContext).modal;
  const [cliente] = useContext(ClienteContext).clienteAtual;
  // FA-08 Fechar
  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(clienteModais.cadastroCliente);
  };

  const DadosClientePessoaFisica = ({ values }) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="cpf" label="CPF" value={formatCPF(values?.pessoaFisica?.cpf)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="identidade" label="Identidade" value={values?.pessoaFisica?.identidade} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateLabel id="dataNascimento" label="Data do nascimento" value={values?.pessoaFisica?.dataNascimento} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="inscricaoMunicipal" label="Inscrição municipal" value={values?.inscricaoMunicipal} />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="observações" label="Observações" value={values?.observacoes} />
        </Grid>
      </>
    );
  };

  const DadosCLienteEmpresaEstrangeiro = ({ values }) => {
    return (
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextLabel
          id="identificadorEstrangeiro"
          label="Identificador estrangeiro"
          value={values?.empresaEstrangeira?.identificadorEstrangeiro}
        />
      </Grid>
    );
  };

  const DadosClientePessoaJuridica = ({ values }) => {
    const { pessoaJuridica, principalAtividadeEconomica, observacoes, inscricaoMunicipal } = values;

    return (
      <>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="cnpj" label="CNPJ" value={formatCNPJ(pessoaJuridica?.cnpj)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="razaoSocial" label="Razão social" value={pessoaJuridica?.razaoSocial} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateLabel id="dataFundacao" label="Data da fundação" value={pessoaJuridica?.dataFundacao} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel
            id="indicadorInscricaoEstadual"
            label="Indicador de inscrição estadual"
            value={INDICADORES[pessoaJuridica?.indicadorInscricaoEstadual]}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="inscricaoEstadual" label="Inscrição estadual" value={pessoaJuridica?.inscricaoEstadual} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="inscricaoMunicipal" label="Inscrição municipal" value={inscricaoMunicipal} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="suframa" label="SUFRAMA" value={pessoaJuridica?.suframa} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="principalAtividadeEconomica"
            label="Principal atividade econômica"
            value={
              principalAtividadeEconomica?.codigo
                ? `${principalAtividadeEconomica.codigo} - ${principalAtividadeEconomica.descricao}`
                : principalAtividadeEconomica?.descricao
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="optanteSimples" label="Optante pelo SIMPLES" value={values?.optanteSimples ? 'Sim' : 'Não'} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="observações" label="Observações" value={observacoes} />
        </Grid>
      </>
    );
  };

  const DadosCliente = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="nome" label="Nome" value={cliente?.pessoa?.nome} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="codigoCliente" label="Código do cliente" value={cliente?.codigoCliente} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="tipoPessoa" label="Tipo de pessoa" value={TIPO_PESSOAS[cliente?.pessoa?.tipoPessoa]} />
        </Grid>
        {cliente?.pessoa?.tipoPessoa === 'FISICA' && (
          <DadosClientePessoaFisica
            values={{
              pessoaFisica: cliente?.pessoa?.pessoaFisica,
              observacoes: cliente?.observacoes,
              inscricaoMunicipal: cliente?.pessoa?.inscricaoMunicipal,
            }}
          />
        )}
        {cliente?.pessoa?.tipoPessoa === 'JURIDICA' && (
          <DadosClientePessoaJuridica
            values={{
              pessoaJuridica: cliente?.pessoa?.pessoaJuridica,
              principalAtividadeEconomica: cliente?.principalAtividadeEconomica,
              observacoes: cliente?.observacoes,
              optanteSimples: cliente?.optanteSimples,
              inscricaoMunicipal: cliente?.pessoa?.inscricaoMunicipal,
            }}
          />
        )}

        {cliente?.pessoa?.tipoPessoa === 'ESTRANGEIRA' && (
          <DadosCLienteEmpresaEstrangeiro
            values={{
              empresaEstrangeira: cliente?.pessoa?.empresaEstrangeira,
              observacoes: cliente?.observacoes,
            }}
          />
        )}

        <Grid item xs={12}>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
            Reforma Tributária
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="contribuinteIbs" label="Contribuinte IBS" value={cliente?.contribuinteIbs ? 'Sim' : 'Não'} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="contribuinteCbs" label="Contribuinte CBS" value={cliente?.contribuinteCbs ? 'Sim' : 'Não'} />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel
            id="tipoIndicadorOperacao"
            label="Tipo indicador operação"
            value={TIPO_INDICADOR_OPERACAO[cliente?.tipoIndicadorOperacao] || cliente?.tipoIndicadorOperacao}
          />
        </Grid>
      </Grid>
    );
  };

  const Content = () => {
    const [expanded, setExpanded] = useState('dadosGerais');

    const handleExpandedChange = (key, value) => {
      if (value) {
        setExpanded(key);
      } else {
        setExpanded(false);
      }
    };

    return (
      <div>
        <CustomExpandedPanel
          title="Dados gerais"
          expanded={expanded === 'dadosGerais'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('dadosGerais', value)}
        >
          <DadosCliente />
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Endereço"
          expanded={expanded === 'endereco'}
          onChange={(_, value) => handleExpandedChange('endereco', value)}
        >
          <Grid container spacing={3}>
            <EnderecoVisualizar endereco={cliente?.pessoa?.endereco} />
          </Grid>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Contato"
          expanded={expanded === 'contato'}
          onChange={(_, value) => handleExpandedChange('contato', value)}
        >
          <Grid container spacing={3} style={{ padding: 16 }}>
            <DadosContatoVisualizar registro={cliente} />
          </Grid>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Conta bancária"
          expanded={expanded === 'contaBancaria'}
          onChange={(_, value) => handleExpandedChange('contaBancaria', value)}
        >
          <Grid container spacing={3}>
            <ContaBancariaVisualizar
              contaBancaria={cliente?.pessoa?.conta?.contaBancaria}
              contaDescricao={cliente?.pessoa?.conta?.descricao}
            />
          </Grid>
        </CustomExpandedPanel>
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === clienteModais.visualizacaoCliente} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de clientes',
          icon: <FaUsers />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>
              {permissaoUtils.cliente().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarClienteModal;
